export default "__VITE_ASSET__C219V3i3__"